
import ChainGcf from '../models/chaingcf';

// CORS?
//const BASE_URL = 'https://www.cathdb.info/version/:version/api/rest';
const BASE_URL = '/api/chaingcf/version/:version';
const RE_CATH_VERSION = /^(v\d_\d_\d|current)$/;
const RE_CHAIN_ID = /^\d\w{3}\w$/;

function is_valid_chainid(chainid) {
    return RE_CHAIN_ID.test(chainid);
}

function is_valid_cath_version(version) {
    return RE_CATH_VERSION.test(version);
}

export default {

    fetchChainGcf(cath_version, chainid) {
        if (!is_valid_cath_version(cath_version)) {
            return new Promise(() => {
                throw new Error(`failed to provide valid cath version for fetchChainGcf: ${cath_version}`);
            });
        }
        if (!is_valid_chainid(chainid)) {
            return new Promise(() => {
                throw new Error(`failed to provide valid chainid for fetchChainGcf: ${chainid}`);
            });
        }
        const url = `${BASE_URL}/id/${chainid}.gcf`.replace(':version', cath_version);
        const promise = new Promise((resolve, reject) => {
            fetch(url)
                .then(r => {
                    console.log("fetchChainGcf.response: ", r);
                    return r.json();
                })
                .then(response => {
                    const gcflines = response.data.split('\n');
                    const re_gcf_line = /^([A-Z])\s+(\d+)\s+([\-\w]+|\*)\s+([A-Z]|\*)\s*$/;
                    const hdr = gcflines.shift();

                    const gcfentries = [];
                    for (const gcfline of gcflines) {
                        if (gcfline.trim() === "") {
                            continue;
                        }
                        const match = gcfline.match(re_gcf_line)
                        if (!match) {
                            throw new Error(`failed to parse gcfline line '${gcfline}' `)
                        }
                        const gcfentry = {
                            seqres_aa: match[1],
                            seqres_num: parseInt(match[2]),
                            pdb_res_label: match[3],
                            atom_aa: match[4],
                        };
                        gcfentries.push(gcfentry);
                    }

                    const chaingcf = new ChainGcf(cath_version, chainid, gcfentries);

                    resolve(chaingcf);
                })
        });
        return promise;
    }
}
